import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/trustauto-logo.png";
import profile from "../assets/profile.svg";
import { useUser } from "../../contexts/UserContext";
import { ImageWithFallback } from "../components/Utilities";

import styles from "./DealerOnboarding.module.css";
import DealerOnboardingNavigation from "./DealerOnboardingNavigation";

export default function DealerOnboarding() {
  const { currentUser, loading, logout } = useUser();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleProfileClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem("onboardingStatus");
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      navigate("/");
    }
    setIsDropdownOpen(false);
  };

  return (
    <div className="container">
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.logo}>
            <ImageWithFallback
              src={logo}
              alt="Trust Auto Logo"
              style={{ height: 40 }}
            />
          </div>
          <div className={styles.headerActions}>
            <p className={styles.welcomeName}>
              {loading
                ? "Loading..."
                : `Welcome, ${
                    currentUser?.name ||
                    currentUser?.email ||
                    localStorage.getItem("name") ||
                    localStorage.getItem("email") ||
                    "User"
                  }`}
            </p>
            <div className={styles.userAvatar} onClick={handleProfileClick}>
              {loading ? (
                <div className="loading-spinner">⏳</div>
              ) : (
                <div className={styles.profilePic}>
                  {currentUser?.profileImageUrl ||
                  localStorage.getItem("profileImageUrl") ? (
                    <img
                      src={
                        currentUser?.profileImageUrl ||
                        localStorage.getItem("profileImageUrl")
                      }
                      alt={
                        currentUser?.name ||
                        localStorage.getItem("userName") ||
                        "User"
                      }
                      className={styles.previewImage}
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "block";
                      }}
                    />
                  ) : null}
                  <ImageWithFallback
                    src={profile}
                    alt="Profile"
                    className={styles.previewImage}
                    style={{
                      display:
                        currentUser?.profileImageUrl ||
                        localStorage.getItem("profileImageUrl")
                          ? "none"
                          : "block",
                    }}
                  />
                </div>
              )}
              {isDropdownOpen && (
                <div className={styles.dropdownHeader}>
                  <button
                    className="dropdown-item"
                    style={{
                      padding: "0.5rem 1rem",
                      width: "100%",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <DealerOnboardingNavigation activeStageLink="dealer-details" />
      <Outlet />
    </div>
  );
}
